import { captureServerException, parseSentryDsn } from "../../supabase/functions/_shared/error-monitoring";

export { captureServerException, parseSentryDsn };

export function initErrorMonitoring(dsn?: string | null): void {
  const parsed = parseSentryDsn(dsn ?? import.meta.env.VITE_SENTRY_DSN);
  if (!parsed || typeof window === "undefined") return;
  void import("@sentry/react")
    .then((Sentry) => {
      Sentry.init({
        dsn: parsed.dsn,
        environment: import.meta.env.MODE,
        tracesSampleRate: 0,
      });
    })
    .catch((error) => {
      console.error("Error monitoring failed to start", error);
    });
}
